// 模拟延迟函数
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// 模拟用户数据库
const mockUsers = {
  steam: {
    'testuser': {
      password: 'test123',
      email: 'test@example.com',
      needEmailVerification: true,
      needTokenVerification: false
    },
    'user2fa': {
      password: 'test123',
      email: 'user2fa@example.com',
      needEmailVerification: true,
      needTokenVerification: true
    }
  },
  krafton: {
    'test@krafton.com': {
      password: 'test123',
      phone: '13800138000',
      needPhoneVerification: true
    }
  }
};

// 模拟CDKey数据库
const mockCDKeys = {
  'TESTKEY123': {
    game: 'PUBG: BATTLEGROUNDS',
    used: false,
    type: 'normal'
  },
  'TESTKEY456': {
    game: 'PUBG: BATTLEGROUNDS',
    used: true,
    type: 'normal',
    usedBy: 'testuser',
    usedTime: '2024-01-13 12:00:00'
  },
  'INVALID123': {
    game: 'Party Animals',
    used: false,
    type: 'normal'
  }
};

// 模拟验证码存储
const verificationCodes = new Map();

export const mockCDKeyService = {
  // Steam验证
  async verifySteam(data) {
    await delay(1000); // 模拟网络延迟

    const user = mockUsers.steam[data.username];
    
    if (!user) {
      throw new Error('账号或密码错误');
    }

    if (user.password !== data.password) {
      throw new Error('账号或密码错误');
    }

    const requiredFields = [];
    if (user.needEmailVerification) {
      requiredFields.push('emailCode');
      // 生成模拟验证码
      const emailCode = Math.random().toString().slice(2, 8);
      verificationCodes.set(`email_${data.username}`, emailCode);
      console.log(`Steam邮箱验证码: ${emailCode}`); // 在控制台显示验证码
    }
    
    if (user.needTokenVerification) {
      requiredFields.push('tokenCode');
      const tokenCode = Math.random().toString().slice(2, 8);
      verificationCodes.set(`token_${data.username}`, tokenCode);
      console.log(`Steam令牌验证码: ${tokenCode}`);
    }

    return {
      success: true,
      required_fields: requiredFields,
      message: requiredFields.length > 0 ? '需要额外验证' : '验证成功'
    };
  },

  // Krafton验证
  async verifyKrafton(data) {
    await delay(1000);

    const user = mockUsers.krafton[data.email];
    
    if (!user) {
      throw new Error('账号或密码错误');
    }

    if (user.password !== data.password) {
      throw new Error('账号或密码错误');
    }

    const requiredFields = [];
    if (user.needPhoneVerification) {
      requiredFields.push('phoneCode');
      const phoneCode = Math.random().toString().slice(2, 8);
      verificationCodes.set(`phone_${data.email}`, phoneCode);
      console.log(`Krafton手机验证码: ${phoneCode}`);
    }

    return {
      success: true,
      required_fields: requiredFields,
      message: requiredFields.length > 0 ? '需要手机验证' : '验证成功'
    };
  },

  // CDKey兑换
  async redeemCDKey(loginMethod, data) {
    await delay(1500);

    // 验证CDKey是否存在和有效
    const cdkey = mockCDKeys[data.cdkey];
    if (!cdkey) {
      throw new Error('无效的CDKey');
    }

    if (cdkey.used) {
      throw new Error('该CDKey已被使用');
    }

    // 验证游戏是否匹配
    if (cdkey.game !== 'PUBG: BATTLEGROUNDS') {
      throw new Error('该CDKey不适用于此游戏');
    }

    // 验证额外字段
    if (loginMethod === 'steam') {
      const user = mockUsers.steam[data.username];
      if (user.needEmailVerification) {
        const savedCode = verificationCodes.get(`email_${data.username}`);
        if (!data.email_code || data.email_code !== savedCode) {
          throw new Error('邮箱验证码错误');
        }
      }
      if (user.needTokenVerification) {
        const savedCode = verificationCodes.get(`token_${data.username}`);
        if (!data.token_code || data.token_code !== savedCode) {
          throw new Error('令牌验证码错误');
        }
      }
    } else if (loginMethod === 'krafton') {
      const user = mockUsers.krafton[data.email];
      if (user.needPhoneVerification) {
        const savedCode = verificationCodes.get(`phone_${data.email}`);
        if (!data.phone_code || data.phone_code !== savedCode) {
          throw new Error('手机验证码错误');
        }
      }
    }

    // 模拟成功兑换
    mockCDKeys[data.cdkey].used = true;
    mockCDKeys[data.cdkey].usedBy = loginMethod === 'steam' ? data.username : data.email;
    mockCDKeys[data.cdkey].usedTime = new Date().toISOString();

    return {
      success: true,
      message: 'CDKey兑换成功！',
      reward: {
        type: cdkey.type,
        items: ['测试物品1', '测试物品2']
      }
    };
  }
};

// 使用示例：
/*
// Steam登录测试用例
const steamTestCase = {
  username: 'testuser',
  password: 'test123',
  cdkey: 'TESTKEY123'
};

// Krafton登录测试用例
const kraftonTestCase = {
  email: 'test@krafton.com',
  password: 'test123',
  cdkey: 'TESTKEY123'
};

// 2FA用户测试用例
const twoFactorTestCase = {
  username: 'user2fa',
  password: 'test123',
  cdkey: 'TESTKEY123'
};
*/

// 组件中的方法
    // async verifyCredentials() {
    //   const method = this.currentLoginMethod;

    //   try {
    //     this.verificationStep = "verifying";
    //     this.isLoading = true;

    //     let result;
    //     if (method.id === "steam") {
    //       result = await mockCDKeyService.verifySteam(this.formData);
    //     } else if (method.id === "krafton") {
    //       result = await mockCDKeyService.verifyKrafton(this.formData);
    //     }

    //     if (result.required_fields?.length > 0) {
    //       this.requiredExtraFields = result.required_fields;
    //       this.hasExtraFields = true;
    //       this.verificationStep = "needExtra";
    //       this.showNotification({
    //         type: "info",
    //         title: "需要验证",
    //         message: result.message,
    //       });
    //       return true;
    //     }

    //     this.verificationStep = "verified";
    //     return true;
    //   } catch (error) {
    //     this.showNotification({
    //       type: "error",
    //       title: "验证失败",
    //       message: error.message,
    //     });
    //     return false;
    //   } finally {
    //     this.isLoading = false;
    //   }
    // },

    // async handleSubmit() {
    //   if (!this.validateForm()) return;

    //   try {
    //     this.isSubmitting = true;
    //     const result = await mockCDKeyService.redeemCDKey(
    //       this.currentLoginMethod.id,
    //       this.formData
    //     );

    //     if (result.success) {
    //       this.showNotification({
    //         type: "success",
    //         title: "兑换成功",
    //         message: result.message,
    //       });
    //       this.resetForm();
    //     }
    //   } catch (error) {
    //     this.showNotification({
    //       type: "error",
    //       title: "兑换失败",
    //       message: error.message,
    //     });
    //   } finally {
    //     this.isSubmitting = false;
    //   }
    // },